/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Description_RequiredInputs */

const en_case_validation_description_required = /** @type {(inputs: Case_Validation_Description_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description is required.`)
};

const pt_br2_case_validation_description_required = /** @type {(inputs: Case_Validation_Description_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição é obrigatória.`)
};

/**
* | output |
* | --- |
* | "Description is required." |
*
* @param {Case_Validation_Description_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_description_required = /** @type {((inputs?: Case_Validation_Description_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Description_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_description_required(inputs)
	return pt_br2_case_validation_description_required(inputs)
});